import { render, staticRenderFns } from "./audioStyle.vue?vue&type=template&id=696fccca&scoped=true"
import script from "./audioStyle.vue?vue&type=script&lang=ts"
export * from "./audioStyle.vue?vue&type=script&lang=ts"
import style0 from "./audioStyle.vue?vue&type=style&index=0&id=696fccca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696fccca",
  null
  
)

export default component.exports